import React from "react";

import { toDate } from "../../../middleware/dates";
import { lang } from "../../../middleware/lang";
import { groupProducts, groupProductsByCategory } from "../../../middleware/product_functions";
import UserBlock from "./userBlock";
import OrderEditHistory from "./orderEditHistory";

const OrderSummary = ({
  order,
  loading,
  productAsDone,
  changeTable,
  saveUser,
  editAddress,
  splitBillMode,
  selectedProducts,
  toggleProductSelection,
  alreadySplitIds,
  comandaSelectMode,
  comandaSelectedProducts,
  toggleComandaProduct,
}) => (
  <div className="col-md-8 px-0 mt-2 mt-md-0">
    <div className="row">
      <div className="col-12">
        <div className="material_card p-3 ">
          <div className="col-12 px-0 mb-2">
            <h1 className="mt-3 mb-0">
              {lang("Orden", "Order")} #{order.id}
              <small>
                <Helper
                  delivery={order.delivery_type}
                  platform_name={order.platform_name}
                  table={order.table}
                  changeTable={changeTable}
                />
              </small>
            </h1>
            <div className=" ">
              <h1 className="">
                <small className="text-muted text_small">
                  {toDate(order.creation_date)}{" "}
                </small>
              </h1>
              <span className={`badge badge-${order.status_color}`}>
                {order.status_text}
              </span>{" "}
              {order.payed ? (
                <span className="badge badge-success">
                  <i className="fas fa-check"></i>
                  {lang(" Pagado", " Payed")}
                </span>
              ) : null}
            </div>
            {order.client_comments && (
              <Comments comment={order.client_comments} />
            )}
            {order.user_comments && (
              <Comments comment={order.user_comments} client />
            )}
            <hr />
          </div>

          <h4>{lang("Productos", "Products")}</h4>
          {splitBillMode && (
            <p className="text-muted small mb-2">
              <i className="fas fa-info-circle mr-1"></i>
              {lang(
                "Selecciona los productos para esta cuenta",
                "Select products for this split",
              )}
            </p>
          )}
          {comandaSelectMode && (
            <p className="text-muted small mb-2">
              <i className="fas fa-info-circle mr-1"></i>
              {lang(
                "Selecciona los productos para re-imprimir en la comanda",
                "Select products to reprint on the kitchen ticket",
              )}
            </p>
          )}
          {loading
            ? null
            : renderProducts(
                order.products,
                productAsDone,
                splitBillMode,
                selectedProducts,
                toggleProductSelection,
                alreadySplitIds,
                comandaSelectMode,
                comandaSelectedProducts,
                toggleComandaProduct,
              )}
        </div>
      </div>
      {!splitBillMode && (
        <UserBlock
          payed={order.payed}
          user={order.user}
          saveUser={saveUser}
          editAddress={editAddress}
          client={order.client}
          address={order.address}
          income={parseFloat(order.cash_income)}
          shipping={order.delivery ? parseFloat(order.delivery) : 0}
          payment_type={order.payment_type}
          card_type={order.card_type}
          branch={order.branch}
          delivery={order.delivery_type}
          platform_name={order.platform_name}
          tip={order.tip ? parseFloat(order.tip) : 0}
          payments={order.payments || []}
        />
      )}
      {!splitBillMode && (
        <div className="col-12 px-0 mt-3">
          <OrderEditHistory order_id={parseInt(order.id, 10)} />
        </div>
      )}
    </div>
  </div>
);

function renderProductItems(
  categoryProducts,
  productAsDone,
  splitBillMode,
  selectedProducts,
  toggleProductSelection,
  alreadySplitIds,
  comandaSelectMode,
  comandaSelectedProducts,
  toggleComandaProduct,
  indexCounterStart,
) {
  const groupedProducts = groupProducts(categoryProducts);
  const rows = [];
  let indexCounter = indexCounterStart;

  groupedProducts.forEach((product) => {
    const productsList = [];
    product.products.forEach((item) => {
      if (splitBillMode && item.qty > 1) {
        const unitPrice = parseFloat(item.price) / item.qty;
        for (let u = 0; u < item.qty; u++) {
          const unitKey = `${item.id}_u${u}`;
          productsList.push(
            <ProductLi
              key={unitKey}
              product={{
                ...item,
                qty: 1,
                price: unitPrice,
                ingredients_txt: item.ingredients_txt,
              }}
              index={indexCounter++}
              productAsDone={null}
              splitBillMode={splitBillMode}
              isSelected={selectedProducts && selectedProducts[unitKey]}
              isAlreadySplit={alreadySplitIds && alreadySplitIds[unitKey]}
              onToggle={toggleProductSelection}
              splitKey={unitKey}
            />,
          );
        }
      } else if (comandaSelectMode) {
        const key = `${item.id}_u0`;
        productsList.push(
          <ProductLi
            key={`${product.id}_${indexCounter}`}
            product={item}
            index={indexCounter++}
            productAsDone={null}
            splitBillMode={true}
            isSelected={comandaSelectedProducts && comandaSelectedProducts[key]}
            isAlreadySplit={false}
            onToggle={toggleComandaProduct}
            splitKey={key}
          />,
        );
      } else {
        const key = splitBillMode ? `${item.id}_u0` : item.id;
        productsList.push(
          <ProductLi
            key={`${product.id}_${indexCounter}`}
            product={item}
            index={indexCounter++}
            productAsDone={productAsDone}
            splitBillMode={splitBillMode}
            isSelected={
              splitBillMode && selectedProducts && selectedProducts[key]
            }
            isAlreadySplit={
              splitBillMode && alreadySplitIds && alreadySplitIds[key]
            }
            onToggle={toggleProductSelection}
            splitKey={splitBillMode ? key : undefined}
          />,
        );
      }
    });
    rows.push(
      <ProductRow key={product.id} product={product} products={productsList} />,
    );
  });

  return { rows, nextIndex: indexCounter };
}

function renderProducts(
  products,
  productAsDone,
  splitBillMode,
  selectedProducts,
  toggleProductSelection,
  alreadySplitIds,
  comandaSelectMode,
  comandaSelectedProducts,
  toggleComandaProduct,
) {
  const categories = groupProductsByCategory(products);
  const result = [];
  let indexCounter = 1;

  categories.forEach((category) => {
    result.push(
      <h5
        key={`cat_${category.id}`}
        className="mt-3 mb-1 text-muted text-uppercase"
        style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
      >
        {category.name}
      </h5>,
    );
    const { rows, nextIndex } = renderProductItems(
      category.products,
      productAsDone,
      splitBillMode,
      selectedProducts,
      toggleProductSelection,
      alreadySplitIds,
      comandaSelectMode,
      comandaSelectedProducts,
      toggleComandaProduct,
      indexCounter,
    );
    result.push(...rows);
    indexCounter = nextIndex;
  });

  return result;
}

const ProductRow = ({ product, products }) => {
  //random number from 1 to 4
  const random_img = Math.floor(Math.random() * 4) + 1;
  return (
    <div className="row my-2 product_row ">
      <div className="col-sm-3 pr-0 d-none d-sm-block">
        <img
          src={
            product.img ||
            `https://s3.amazonaws.com/ftp-foo/page_assets/no_photo_0${random_img}.jpg`
          }
          className="img-thumbnail "
          alt={product.title}
        />
      </div>

      <div className="col-12 d-sm-none">
        <div
          className="order_img d-flex justify-content-center align-items-center"
          style={{
            backgroundImage: `url(${product.img})`,
          }}
        >
          <h2 className="txt_on_img text-center background_text">
            {product.title}
          </h2>
        </div>
      </div>
      <div className="col-sm-9 pl-sm-1">
        <h4 className="ml-2 font-weight-bold">{product.title}</h4>
        <div className="list-group">{products}</div>
      </div>
    </div>
  );
};

const ProductLi = ({
  product,
  productAsDone,
  index,
  splitBillMode,
  isSelected,
  isAlreadySplit,
  onToggle,
  splitKey,
}) => {
  if (splitBillMode) {
    const disabled = isAlreadySplit;
    const toggleId = splitKey || product.id;
    return (
      <div
        className={`list-group-item list-group-item-action flex-column product_in_order align-items-start flat-top_mob ${
          isSelected ? "done" : ""
        } ${disabled ? "opacity_6" : ""}`}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        onClick={disabled ? undefined : () => onToggle(toggleId)}
      >
        <div className="row">
          <div className="col-9">
            <h5 className="mb-1">
              {index}.-{" "}
              {product.ingredients_txt || lang("Con Todo", "All the Way")}{" "}
              <i
                className={`far mr-1 ${
                  isSelected
                    ? "fa-check-square text-success big_entrance_anm fast"
                    : disabled
                      ? "fa-check-square text-muted"
                      : "fa-square text-muted"
                }`}
                aria-hidden="true"
              ></i>
            </h5>
          </div>
          <div className="col-3 text-right">
            <small>${parseFloat(product.price).toFixed(2)}</small>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`list-group-item list-group-item-action flex-column product_in_order align-items-start flat-top_mob  ${
        product.status === "1" ? "done" : ""
      }`}
      id="product_28243"
    >
      <button
        className="btn btn_full btn_invisible "
        data-product_id={product.id}
        onClick={productAsDone}
      ></button>
      <div className="row">
        <div className="col-9">
          <h5 className="mb-1">
            {" "}
            {index}.-{" "}
            {product.ingredients_txt || lang("Con Todo", "All the Way")}
            {product.qty > 1 ? ` x${product.qty} ` : " "}
            <Checkbox
              qty={product.qty}
              qty_done={product.qty_done}
              status={product.status}
              product_id={product.id}
            />
          </h5>
        </div>

        <div className="col-3 text-right">
          <small>${product.price}</small>
        </div>
        {product.comments && (
          <div className="col-12">
            <hr />
            <p className="">
              <small>Comentarios: </small> <br />
              {product.comments} - <small> </small>{" "}
              <i className="fas fa-comment text-danger" aria-hidden="true"></i>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const Helper = ({ delivery, platform_name, table, changeTable }) => {
  let table_render = null;
  let help_text = {};
  if (table) {
    table_render = (
      <React.Fragment>
        <span className="badge badge-secondary ml-2">
          {renderTableName(table.name)}
          <span id="table_name">{table.name || `#${table.id}`}</span>
        </span>
        <button className="btn btn-link text-left" onClick={changeTable}>
          <i className="fas fa-edit"></i>
        </button>
      </React.Fragment>
    );
  }

  switch (delivery) {
    case "pickup":
      help_text.txt = "Para Recoger";
      help_text.icon = "fas fa-hand-point-up mr-2";
      break;
    case "delivery":
      help_text.txt = "Envío a Domicilio";
      help_text.icon = "fas fa-motorcycle mr-2";
      break;
    case "other_apps":
      help_text.txt = platform_name ? `Plataformas - ${platform_name}` : "Plataformas";
      help_text.icon = "fas fa-mobile-alt mr-2";
      break;

    default:
      help_text.txt = "En Comedor";
      help_text.icon = "far fa-circle";
      break;
  }
  return (
    <React.Fragment>
      <span className="badge badge-light mx-2">
        <i className={help_text.icon}></i> {help_text.txt}
      </span>
      {table_render}
    </React.Fragment>
  );
};

const Checkbox = ({ qty, product_id, qty_done, status }) => {
  const done_icon = "fa-check-square text-success big_entrance_anm fast";
  const pending_icon = "text-muted fa-square";
  const allDone = status === "1" || status === 1;
  const donCount = allDone ? qty : (qty_done || 0);
  const response = [];
  for (let i = 1; i <= qty; i++) {
    response.push(
      <i
        className={`far mr-1 ${i <= donCount ? done_icon : pending_icon}`}
        key={`${product_id}_qty_${i}`}
        aria-hidden="true"
      ></i>,
    );
  }
  return response;
};

const Comments = ({ comment, client }) => (
  <div className={`comments ${client ? "px-3 py-2 rounded bg-warning" : ""}`}>
    <h4 className="font-black">Comentarios{client ? " del Cliente:" : ":"}</h4>
    <p className={`${client ? "bg-light p-2 rounded m-0" : "my-0 ml-2"}`}>
      {comment}
    </p>
  </div>
);

const renderTableName = (name) => {
  if (!name || (name && name.length <= 2)) {
    return lang("Mesa ", "Table ");
  }
  return "";
};
export default OrderSummary;
